import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import Box from '@material-ui/core/Box'
import S3 from 'react-aws-s3'

import Close from '@material-ui/icons/Close'

import React, { useContext, useEffect, useState } from 'react'
import { useFeatures } from '../../../hooks/Features/useFeatures'
import useValidation from '../../../hooks/Validation/useValidation'
import CustomButton from '../../CustomButton'
import CustomHeading from '../../CustomHeading'
import CustomInput from '../../CustomInput'
import CustomSelect from '../../CustomSelect'
import { config } from '../../../utils/uploadImage'
import { Avatar, CircularProgress, makeStyles } from '@material-ui/core'
import { CategoryContext } from '../../../context api/Category/CategoryContext'
import { useCategory } from '../../../hooks/Features/useCategory'

const useStyles = makeStyles((theme) => ({
  input: {
    [theme.breakpoints.up('md')]: {
      //
    },
    [theme.breakpoints.up('lg')]: {
      width: '100%',
    },
  },
}))

export default function SubCategoryForm({ subCategory, handleClose }) {
  //   const [category, setCategory] = useState(product ? product.categoryId && product.categoryId._id : '')
  const classes = useStyles()
  const [name, setName] = useState('')
  const [image, setImage] = useState('')
  const [category, setCategory] = useState('')
  const [description, setDescription] = useState('')
  const { handleValidation, error } = useValidation()
  //console.log('category : ', subCategory)
  const { addsubCategory, updatesubCategory } = useFeatures()
  const { getAllCategories } = useCategory()

  const { categories } = useContext(CategoryContext)
  useEffect(() => {
    getAllCategories()
  }, [])
  useEffect(() => {
    if (subCategory) {
      setName(subCategory.name)
      setImage(subCategory.image)
      setDescription(subCategory.description)
      setCategory(subCategory.categoryId && subCategory.categoryId._id)
    }
  }, [subCategory])

  const productInputs = [
    { label: 'Category', select: true, value: category, handleChange: setCategory },
    { label: 'Name', value: name, handleChange: setName },
    { label: 'Description', value: description, handleChange: setDescription },
    { handleChange: setImage, type: 'file' },
  ]

  const handleAddCategory = async () => {
    addsubCategory({
      categoryId: category,
      name,
      description,
      image,
    })
    handleClose()
    setName('')
    setDescription('')
  }
  const handleEditCategory = async () => {
    updatesubCategory({
      categoryId: category,
      subCategoryId: subCategory._id,
      name,
      description,
      image,
    })
    handleClose()
    setName('')
    setDescription('')
  }
  const disableButton = category && name && description && image ? false : true

  return (
    <>
      <Box display="flex" justifyContent="space-between">
        <CustomHeading heading={subCategory ? 'Update SubCategory' : 'Add SubCategory'} />
        <IconButton color="inherit" onClick={handleClose} size="small">
          <Close />
        </IconButton>
      </Box>
      <br />
      <Grid container>
        {productInputs.map((item, index) => (
          <Grid item lg={12} key={index}>
            {item.select ? (
              <>
                <CustomSelect
                  label={item.label}
                  value={item.value}
                  handleChange={item.handleChange}
                  onKeyDown={() => handleValidation(item.type, item.value)}
                  errorMessage={error && item.error}
                  options={categories}
                  className={classes.input}
                />
                <br />
              </>
            ) : (
              <>
                <CustomInput
                  label={item.label}
                  value={item.value}
                  handleChange={item.handleChange}
                  onKeyDown={() => handleValidation(item.type, item.value)}
                  errorMessage={error && item.error}
                  type={item.type ? item.type : 'text'}
                  className={classes.input}
                />
                <br />
              </>
            )}
          </Grid>
        ))}

        {subCategory ? (
          <div style={{ display: 'flex', margin: '0 auto' }}>
            <Avatar src={subCategory.image} />
          </div>
        ) : null}
        <Grid item lg={12}>
          <CustomButton
            text={subCategory ? 'Update' : 'Add'}
            handleSubmit={subCategory ? handleEditCategory : handleAddCategory}
            // disabled={disableButton}
          />
        </Grid>
      </Grid>
    </>
  )
}
